export const PRICE_REFRESH_TEXT = 'Prices and discounts are being recalculated';
export const REFRESH_TEXT = 'Refresh';

// Price Reveal Constants
export const PRICE_TEXT = 'Price';
export const PRICE_COMING_SOON = 'Price Coming Soon';
export const SHOW_PRICE = 'Show Price';
export const ADD_TO_WISHLIST = 'Add to Wishlist';
export const GO_TO_WISHLIST = 'Go to Wishlist';
export const PRE_BUZZ = 'PRE_BUZZ';
export const DURING_SALE = 'DURING_SALE';
export const SHOW_MRP_TEXT = 'MRP';
